export enum IdType {
  STRING = "String",
  INTEGER = "Integer",
  UUID = "UUID",
}

export enum PhoneType {
  OTHER = "Other",
  PRIMARY = "Primary",
  MOBILE = "Mobile",
  WORK = "Work",
  OFFICE = "Office",
  FAX = "Fax",
}

export enum AddressType {
  OTHER = "Other",
  PRIMARY = "Primary",
  POST_BOX = "PostBox",
  POSTAL = "Postal",
  RESIDENTIAL = "Residential",
  OFFICE = "Office",
}

export enum NameType {
  NAME = "Name",
  FIRST = "First",
  LAST = "Last",
}
